import { memo } from 'react';
import icons from './icons.map';
import type { SuperIconProps } from './SuperIcon.types';
import { useSuperIcon } from './useSuperIcon';

function SuperIconBase(props: SuperIconProps) {
  const { name, color, style } = props;
  const vm = useSuperIcon(props);
  const Renderer = icons[name];

  return (
    <svg
      width={vm.pixelSize}
      height={vm.pixelSize}
      viewBox="0 0 24 24"
      className={vm.className}
      style={style}
      {...vm.ariaProps}
    >
      {Renderer({ stroke: vm.stroke, color })}
    </svg>
  );
}

export const SuperIcon = memo(SuperIconBase);
